__turbopack_context__.v({
  "offer-card-gallery": "OfferCardGallery-module-scss-module__U23Eha__offer-card-gallery",
  "offer-card-gallery__grid": "OfferCardGallery-module-scss-module__U23Eha__offer-card-gallery__grid",
  "offer-card-gallery__title": "OfferCardGallery-module-scss-module__U23Eha__offer-card-gallery__title",
});
